import React from "react"

import { useTimeDifferenceText } from "shared/lib/useTimeDifferenceText"

interface TimeDifferenceProps {
  timeStamp: string | null | undefined
}

export const TimeDifference = React.memo(
  ({ timeStamp }: TimeDifferenceProps) => {
    const timeDifference = useTimeDifferenceText(timeStamp)
    return <div className="time-difference">{timeDifference}</div>
  }
)
